import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { IntegrationsAPI } from "../../../providers/IntegrationsAPI";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Loading } from "../../components/Loading";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { Checkbox } from "../../components/Checkbox";
import { Toggle } from "shared/components/Toggle";
import { Context } from "pages/Integrations";

export default class FoodyDeliveryDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      environment: EnvironmentStorage.getEnvironment(),
      active: true,
      apiToken: null,
      webhookToken: null,
      webhookUrl: null,
      cancelationControl: false,
    };
  }

  componentDidMount() {
    this.loadAccount();
  }

  async loadAccount() {
    const { environment } = this.state;

    const accountResponse = await IntegrationsAPI.getFoodDeliveryAccount(
      environment.id
    );
    const account = accountResponse.getData({});

    this.setState({
      active: account?.active,
      cancelationControl: account?.cancelationControl || false,
      apiToken: account?.apiToken,
      webhookToken: account?.webhookToken,
      webhookUrl: account?.webhookUrl,
      loadingPage: false,
    });
  }

  async updateAccount() {
    const { environment, active, cancelationControl, apiToken, webhookToken } = this.state;

    this.setState({
      loading: true,
    });

    const updateResponse = await IntegrationsAPI.setFoodDeliveryAccount({
      environmentId: environment.id,
      active,
      cancelationControl,
      apiToken, webhookToken
    });

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
      this.setState({
        loading: false,
      });
      return false;
    }

    this.setState({
      loading: false,
    });

    return true;
  }

  async copyWebhookUrl () {
    const { webhookUrl } = this.state;
    await navigator.clipboard.writeText(webhookUrl);
  }

  async changeStep(newStep) {
    this.setState({
      step: newStep,
    });
  }

  render() {
    const {
      loading,
      loadingPage,
      active,
      cancelationControl,
      apiToken,
      webhookToken,
      webhookUrl,
    } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Foody Delivery"
      >
        <Context />

        {loadingPage && (
          <div className={styles.loading}>
            <Loading />
          </div>
        )}
        {!loadingPage && (
          <div className={styles.scrollContainer}>
            <div className={styles.toggle}>
              <div className="d-flex justify-end w-100">
                <Toggle
                    active={active}
                    onChange={(active) => this.setState({ active })}
                />
              </div>
            </div>

            <Input
              design="two"
              label="Token da API"
              className="mb-20"
              value={apiToken}
              onChange={(e) =>
                this.setState({
                  apiToken: e.target.value.trim(),
                })
              }
            />

            <Input
              design="two"
              label="Token do webhook"
              className="mb-20"
              value={webhookToken}
              onChange={(e) =>
                this.setState({
                  webhookToken: e.target.value.trim(),
                })
              }
            />

            <Input
              design="two"
              label="URL do webhook"
              className="mb-10"
              value={webhookUrl}
            />

            <Button
              design="primary"
              className="w-100 mb-20"
              onClick={() => this.copyWebhookUrl()}
            >
              Copiar URL do webhook
            </Button>

            <Checkbox
              name="cancelationControl"
              design="two"
              checked={cancelationControl}
              onChange={() =>
                this.setState({
                  cancelationControl: !cancelationControl,
                })
              }
            >
              Cancelar pedido quando o operador logístico cancelar ou não
              conseguir efetuar a entrega?{" "}
            </Checkbox>

            <div className={styles.footer}>
              <Button
                design="primary"
                className="w-100"
                onClick={() =>
                  this.updateAccount()
                }
                loading={loading}
                disabled={loading}
              >
                Salvar
              </Button>
            </div>
          </div>
        )}
      </Drawer>
    );
  }
}
